export class Vector2 {

  x = 0;
  y = 0;

  constructor(x, y) { 
    this.x = x;
    this.y = y;
  }

  add(other) {
    return new Vector2(this.x + other.x, this.y + other.y);
  }

  middle(other) {
    return new Vector2(
      ((other.x - this.x) / 2) + this.x, 
      ((other.y - this.y) / 2) + this.y
    );
  }

  rotate(angle) {
    return new Vector2(
      this.x * Math.cos(angle) - this.y * Math.sin(angle),
      this.x * Math.sin(angle) + this.y * Math.cos(angle),
    )
  }

  getAngle(destination) {
    var x = destination.x - this.x;
    var y = destination.y - this.y;

    if(y == 0){
      return -Math.PI / 2;
    }

    return -Math.atan2(x, y);
  }

  distanceTo(other) {
    var a = other.x - this.x;
    var b = other.y - this.y;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    return c;
  }

}